import React from 'react';
import { Link } from 'react-router-dom';

const ACTIONS = [
  { to: '/message-composer', icon: 'fa-pen-nib', label: 'New message', bg: '#FFF7F0', color: '#EA580C' },
  { to: '/audience-builder', icon: 'fa-bullseye', label: 'Build audience', bg: '#EFF6FF', color: '#074f78' },
  { to: '/reports', icon: 'fa-chart-bar', label: 'View reports', bg: '#EDE9FE', color: '#7C3AED' },
  { to: '/audit-log', icon: 'fa-file-lines', label: 'Audit log', bg: '#F1F5F9', color: '#475569' },
];

export default function DashboardQuickActions() {
  return (
    <div className="db-quick-grid">
      {ACTIONS.map((a) => (
        <Link key={a.to} to={a.to} className="db-quick-tile">
          <i className={`fas ${a.icon}`} style={{ background: a.bg, color: a.color }} />
          {a.label}
        </Link>
      ))}
    </div>
  );
}
